import { CameraState } from '@curvewise/common-types'

export const DEFAULT_INITIAL_VIEW: CameraState = {
  position: [0, 0, 2],
  target: [0, 0, 0],
  up: [0, 1, 0],
  zoom: 1.0,
}
